import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizeWords',
    standalone: true,
})
export class CapitalizeWordsPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) return '';
        return value.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
    }
}
